import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=05242462&scoped=true&"
import script from "./EventPage.vue?vue&type=script&lang=ts&"
export * from "./EventPage.vue?vue&type=script&lang=ts&"
import style0 from "./EventPage.vue?vue&type=style&index=0&id=05242462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05242462",
  null
  
)

export default component.exports